module.exports = __webpack_public_path__ + "static/img/otp.b70d9f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/otp.jpg
// module id = g5ej
// module chunks = 0